var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("销售价:"+_vm._s(_vm.storeObj.storeNumPrice))]),_vm._v(" "),_c('p',[_vm._v("活动价:"+_vm._s(_vm.storeObj.storeActivityNumPrice))]),_vm._v(" "),_c('p',[_vm._v("指导价:"+_vm._s(_vm.storeObj.numPrice))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-479effe2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/store/storeColums.vue
// module id = null
// module chunks = 